import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import deconnecterUtilisateur from '../../store/deconnexion';

const Deconnexion = ({ deconnecterUtilisateurAction }) => {
    useEffect(() => {
        deconnecterUtilisateurAction();
    }, []);

    return <></>;
};

Deconnexion.propTypes = {
    deconnecterUtilisateurAction: PropTypes.func.isRequired,
};

export default connect(() => {}, { deconnecterUtilisateurAction: deconnecterUtilisateur })(
    Deconnexion,
);
